const STATUS = {
  ONLINE: 'ONLINE',
  OFFLINE: 'OFFLINE'
};

const initial = {
  network: STATUS.ONLINE
};

export default function networkStatus(state = initial, action) {
  if (action.type === 'SET_NETWORK_STATUS') {
    const { status } = action;
    return {
      ...state,
      network: status === 1 ? STATUS.OFFLINE : STATUS.ONLINE
    };
  }
  return state;
}
